/* eslint-disable @typescript-eslint/no-explicit-any */
import { showLoader, hideLoader } from 'store/loader/actions';
import PAGES from 'constants/pages';
import requester from 'utils/requester';
import api from 'config/api';
import { DetailsObjectType } from './loaders/loader-types';
import { loadPageData } from './api';
import { selectPages } from './selectors';
import { AsyncAction } from '../types';
import {
  LOAD_DATA,
  LOAD_DATA_SUCCESS,
  LOAD_DATA_ERROR,
  TOGGLE_FAVORITE_STATUS_SUCCESS,
  RESET_DATA,
} from './action-types';

type PagesType = keyof typeof PAGES;

type LoadDataPayloadType = {
  pageId: PagesType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  params?: any;
  loader?: boolean;
};

export const loadData: AsyncAction<LoadDataPayloadType> = ({
  pageId,
  params = {},
  loader = true,
}) => async (dispatch, getState) => {
  try {
    if (loader) dispatch(showLoader());

    const state = selectPages(getState());
    dispatch({ type: LOAD_DATA, payload: { pageId, params } });
    const data = await loadPageData(pageId, { params, state });
    dispatch(loadDataSuccess({ pageId, data, params }));
  } catch (error) {
    console.error(error);
    dispatch(loadDataError({ pageId, params, message: error.message }));
  } finally {
    if (loader) dispatch(hideLoader());
  }
};

type loadDataSuccessPayload = {
  pageId: PagesType;
  data: any;
  params: any;
};

export const loadDataSuccess = (payload: loadDataSuccessPayload) => ({
  type: LOAD_DATA_SUCCESS,
  payload,
});

export const loadDataError = (payload) => ({ type: LOAD_DATA_ERROR, payload });

export const resetData = () => ({ type: RESET_DATA });

export const toggleFavoriteStatus = (payload: DetailsObjectType) => async (dispatch) => {
  try {
    if (!payload) return;

    const id = payload.id;
    const favorite = payload.favorite;
    const type = payload.type;

    const command = favorite ? 'remove-from-favorites' : 'add-to-favorites';

    await requester({
      method: 'post',
      url: `${api.host}${api.endpoints.assets}/${id}/commands/${command}`,
    });

    dispatch({
      type: TOGGLE_FAVORITE_STATUS_SUCCESS,
      payload: { id, type, favorite: !favorite },
    });
  } catch (error) {
    console.error(error);
  }
};
